import React, {useState, memo} from 'react';
import cx from 'classnames';
import {Image} from 'src/components/image';
import {Modal, Slide} from '@mui/material';
import Div100vh from 'src/components/div100vh';
import {Backdrop} from 'src/components/backdrop';
import {ReactComponent as X} from 'src/images/svg/X.svg';

import * as styles from './images.module.css';

const truncate = (str, max = 10) => {
	const array = str.trim().split(' ');
	const ellipsis = array.length > max ? '...' : '';

	return array.slice(0, max).join(' ') + ellipsis;
};

const CaptionDrawer = ({image, active, toggle}) => {
	return (
		<Modal
			open={active}
			onClose={() => toggle()}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{active: active, toggle: toggle}}
			aria-modal="true"
			style={{zIndex: 99999}}>
			<Slide
				direction="left"
				in={active}
				timeout={{
					enter: 500,
					exit: 250,
				}}>
				<div className={cx(styles.captionDrawer)}>
					<Div100vh className={cx(styles.captionDrawerContent)}>
						<button
							className={cx('reset', styles.closeButton)}
							onClick={toggle}>
							<X />
						</button>
						<Image
							className={styles.captionDrawerImage}
							imageId={image.asset._id}
							alt={image.alt}
							style={{
								maxHeight: '400px',
								margin: '0 auto',
							}}
							objectFit="contain"
						/>
						<p className={cx(styles.captionDrawerCopy)}>
							{image.caption}
						</p>
					</Div100vh>
				</div>
			</Slide>
		</Modal>
	);
};

const BlockImage = ({image}) => {
	const [captionIsOpen, setCaptionIsOpen] = useState(false);
	const toggleCaption = () => setCaptionIsOpen(!captionIsOpen);

	const {caption} = image;

	const wordCount = caption && caption.split(' ').length;
	const truncatedCaption = caption && truncate(caption, 12);

	return (
		<div className={styles.imageContainer}>
			<Image
				className={styles.image}
				imageId={image.asset._id}
				alt={image.alt}
				style={{
					maxHeight: '600px',
					margin: '0 auto',
				}}
				objectFit="contain"
			/>
			<p className={cx('caption', styles.caption)}>
				{wordCount > 12 ? truncatedCaption : image.caption}
				{wordCount > 12 && (
					<button
						className={cx('reset', styles.captionDrawerButton)}
						onClick={toggleCaption}>
						<span className="label-italic underline-on-hover">
							Read More
						</span>
					</button>
				)}
			</p>

			<CaptionDrawer
				image={image}
				active={captionIsOpen}
				toggle={toggleCaption}
			/>
		</div>
	);
};

export const BlockImages = ({images}) => {
	return (
		<div className={styles.images}>
			<div className={styles.inner}>
				{images &&
					images.map(image => {
						return <BlockImage image={image} key={image._key} />;
					})}
			</div>
		</div>
	);
};
